import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { PushPopItem, PushPopService } from "@app/services/push.pop.service";
import {
    ActivatedRoute,
    NavigationEnd,
    NavigationStart,
    Router,
    RouterState,
} from "@angular/router";
import { Subscription } from "rxjs";
import { CommonService } from "@app/services/CommonService";
import { WindowToken } from "@app/util/window.token";

@Component({
    selector: "app-push-pop-footer",
    template: require("./push.pop.footer.component.html"),
})
export class PushPopFooterComponent implements OnInit, OnDestroy {
    bodyElement: HTMLBodyElement;
    items: PushPopItem[] = [];
    currentSection: string;
    routerEventSubscription: Subscription;
    fromStateName: string;
    fromState: RouterState;
    fromParams: any;
    toUrl: string;
    toStateName: string;
    toState: RouterState;
    toParams: any;

    constructor(
        @Inject(DOCUMENT) private $document: Document,
        @Inject(WindowToken) private $window: Window,
        @Inject(PushPopService) private pushPopService: PushPopService,
        @Inject(CommonService) private commonService: CommonService,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.routerEventSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.fromState = this.router.routerState;
                this.fromParams = JSON.parse(
                    JSON.stringify(this.$window.history.state || {})
                );
                delete this.fromParams["navigationId"];
                this.fromStateName = this.sectionOf(this.route);
            }

            if (event instanceof NavigationEnd) {
                this.toState = this.router.routerState;
                this.toUrl = this.toState.snapshot.url;
                this.toParams = JSON.parse(
                    JSON.stringify(this.$window.history.state || {})
                );
                delete this.toParams["navigationId"];
                this.toStateName = this.sectionOf(this.route);

                this.pushPopService
                    .updateOnStateChange(
                        this.fromStateName,
                        this.fromParams,
                        this.toUrl,
                        this.toStateName,
                        this.toParams
                    )
                    .then(
                        () => {
                            this.currentSection =
                                this.pushPopService.getSection();
                            this.commonService.setPushPopUpdateSuccess();
                        },
                        () => {
                            // console.log('invalid section')
                        }
                    );
            }
        });

        this.bodyElement = this.$document.querySelector("body");
        this.items = this.pushPopService.getFooterItems();

        this.currentSection = this.pushPopService.currentSection;
    }

    private sectionOf(route: ActivatedRoute): string | null {
        let r = route;
        while (r.firstChild) {
            r = r.firstChild;
        }
        return r.snapshot?.data?.["section"] ?? null;
    }

    onBlur() {
        this.bodyElement.classList.remove("stateTransitionBackward");
        this.bodyElement.classList.add("stateTransitionForward");
    }

    ngOnDestroy() {
        if (this.routerEventSubscription) {
            this.routerEventSubscription.unsubscribe();
        }
    }
}
